import { Stack, Typography } from '@mui/material';
import { Routes } from 'enums';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import useAppBarNavigationStore, { NavigationStates } from 'stores/app-bar-navigation-store';
import { makeStyles } from 'tss-react/mui';
import { ProjectWrapperKeys } from '../profile-generator/use-query-project-wrapper';
import { ProjectWrapper } from './linkedin-crawler-overview';

interface Props {
  isEven: boolean;
  wrapper: ProjectWrapper;
  type: 'normal' | 'li_search' | undefined;

  handleOpenConfirmDeleteDialog(wrapper: ProjectWrapper): () => void;
}

const ProjectWrapperItem: React.FC<Props> = ({ isEven, wrapper, type, handleOpenConfirmDeleteDialog }) => {
  const { classes } = useStyles({ isEven });
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { setAppBarNavigation } = useAppBarNavigationStore((state) => ({ setAppBarNavigation: state.setActiveTab }));

  const goToProject = () => {
    setAppBarNavigation(NavigationStates.TOOL);
    const route =
      type === 'normal'
        ? `${Routes.PERSONA_GENERATOR}?${ProjectWrapperKeys.CLASSIFICATION_PROJECT}=${wrapper._id}`
        : `${Routes.URL_FINDER}?${ProjectWrapperKeys.URL_FINDER_PROJECT}=${wrapper._id}`;
    navigate(route, { state: location.state });
  };

  return (
    <Stack className={classes.funnelItem} direction={'row'} alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'}>
      <Typography className={classes.text}>{wrapper.name}</Typography>
      <Stack direction={'row'} spacing={2}>
        <PaiLink text={t('edit')} size={'sm'} variant={'primary'} underline={'always'} textTransform={'lowercase'} action={goToProject} />
        <PaiLink
          text={t('delete')}
          size={'sm'}
          variant={'primary'}
          underline={'always'}
          textTransform={'lowercase'}
          action={handleOpenConfirmDeleteDialog(wrapper)}
        />
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles<{ isEven: boolean }>()((theme, { isEven }) => ({
  funnelItem: {
    position: 'relative',
    width: '100%',
    padding: '8px 16px',
    background: isEven ? '#FFF' : theme.palette.backgrounds.main,
    minHeight: '40px',
  },
  text: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.greys.medium,
    marginTop: '1.5px',
  },
}));

export default ProjectWrapperItem;
